// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/Footer.tsx
// Version: v1.4.0
// Description: Footer — "Cookie-Einstellungen" button resets consent and re-shows banner

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const handleCookieSettings = (e: React.MouseEvent) => {
    e.preventDefault();
    localStorage.removeItem('_est_cookie_consent');
    window.location.reload();
  };

  return (
    <footer className="w-full bg-black text-white py-[75px] md:py-[75px] lg:py-[100px]">
      <div className="max-w-[1700px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 text-md">
          
          <div className="col-span-2 md:col-span-4 lg:col-span-2 mb-8 md:mb-8 lg:mb-0">
            <Link to="/" className="flex items-center">              
              <span className="text-white text-4xl font-black">estata.com</span>
            </Link>
              <span className="text-white text-1xl font-normal">Make it happen with estata</span>
          </div>

          <div>            
            <ul className="space-y-3">
              <li><Link to="/services" className="text-white hover:text-white/80">Services</Link></li>
              <li><Link to="/services" className="text-white hover:text-white/80">Branchen</Link></li>              
              <li><Link to="/careers" className="text-white hover:text-white/80">Karriere</Link></li>
              <li><Link to="/about" className="text-white hover:text-white/80">Über uns</Link></li>              
            </ul>
          </div>

          <div>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-white hover:text-white/80">Kontakt</Link></li>
              <li><Link to="/contact" className="text-white hover:text-white/80">Standort</Link></li>
              <li><Link to="/careers" className="text-white hover:text-white/80">Jobsuche</Link></li>
              <li><Link to="/myest/" className="text-white hover:text-white/80">MYest</Link></li>
            </ul>
          </div>

          <div>            
            <ul className="space-y-3">
              <li><Link to="/about" className="text-white hover:text-white/80">Unternehmen</Link></li>
              <li><Link to="/about" className="text-white hover:text-white/80">People & Culture</Link></li>              
              <li><Link to="/about" className="text-white hover:text-white/80">Inklusion & Vielfalt</Link></li>
              <li><Link to="/about" className="text-white hover:text-white/80">Nachhaltigkeit</Link></li>              
            </ul>
          </div>   
                 
          <div>
            <ul className="space-y-3">
              <li><Link to="/imprint" className="text-white hover:text-white/80">Impressum</Link></li>
              <li><Link to="/privacy-policy" className="text-white hover:text-white/80">Datenschutzrichtlinie</Link></li>
              <li><Link to="/terms-of-use" className="text-white hover:text-white/80">Nutzungsbedingungen</Link></li>
              <li>
                <button
                  onClick={handleCookieSettings}
                  className="text-white hover:text-white/80 text-left"
                >
                  Cookie-Einstellungen
                </button>
              </li>
              <li><Link to="/accessibility-statement" className="text-white hover:text-white/80">Barrierefreiheit</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white mt-8 pt-8 text-left">
          <p className="text-white">
            Copyright © 2025 ESTATA. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
